<template>
    <div>
        <div class="d-flex justify-content-end mb-3">
            <button data-testid="company-group-new" type="button" class="btn btn-primary" @click="openCreateForm">
                <i class="fas fa-plus me-1" /> {{ $t('str.btn.new.form') }}
            </button>
        </div>
        <panel v-if="isFormVisible" :title="$t('str.company.groups.title')">
            <form data-testid="company-group-form" class="row g-3" @submit.prevent="save">
                <div class="col-md-4"><label class="form-label">{{ $t('str.company.groups.name') }}</label><input v-model.trim="form.name" class="form-control" required /></div>
                <div class="col-md-8"><label class="form-label">{{ $t('str.company.groups.description') }}</label><input v-model.trim="form.description" class="form-control" /></div>
                <div class="col-md-6"><label class="form-label">{{ $t('str.company.groups.accounts') }}</label><v-select v-model="form.accounts" multiple label="name" :options="accounts" :reduce="item => item._id" /></div>
                <div class="col-md-6"><label class="form-label">{{ $t('str.company.groups.members') }}</label><v-select v-model="form.members" multiple label="fullName" :options="groupAdmins" :reduce="item => item._id" /></div>
                <div class="col-12"><p class="text-muted">Operadores associados acessam o Monitoramento de parceiros, sem permissões administrativas sobre as empresas.</p>
                    <button class="btn btn-primary me-2" :disabled="saving || !form.name || form.accounts.length === 0"><i v-if="saving" class="fas fa-spinner fa-spin" /> {{ $t('str.btn.save') }}</button>
                    <button type="button" class="btn btn-default" @click="resetForm">{{ $t('str.btn.cancel') }}</button>
                </div>
            </form>
        </panel>
        <panel class="mt-3" :title="$t('str.company.groups.list')" bodyClass="p-0">
            <div class="table-responsive"><table class="table table-hover mb-0">
                <thead><tr><th>{{ $t('str.company.groups.name') }}</th><th>{{ $t('str.company.groups.accounts') }}</th><th>{{ $t('str.company.groups.members') }}</th><th /></tr></thead>
                <tbody>
                    <tr v-for="group in groups" :key="group._id"><td>{{ group.name }}</td><td>{{ namesFor(group.accounts, accounts) }}</td><td>{{ namesFor(group.members, groupAdmins, 'fullName') }}</td><td class="text-end"><button class="btn btn-sm btn-default me-2" @click="edit(group)">{{ $t('str.btn.edit') }}</button><button class="btn btn-sm btn-warning" @click="archive(group)">{{ $t('str.btn.archive') }}</button></td></tr>
                    <tr v-if="!loading && groups.length === 0"><td colspan="4" class="text-center text-muted">{{ $t('str.table.subtitle.no.data') }}</td></tr>
                </tbody>
            </table></div>
        </panel>
    </div>
</template>

<script>
import Endpoints from '../../../common/Endpoints.vue'
import Request from '../../../common/Request.vue'
import Services from '../../../common/Services.vue'
import Common from '../../../common/Common.vue'

const emptyForm = () => ({ _id: '', name: '', description: '', accounts: [], members: [] })
const idOf = value => (typeof value === 'object' ? value?._id : value)

export default {
    data: () => ({ groups: [], accounts: [], groupAdmins: [], form: emptyForm(), isFormVisible: false, loading: false, saving: false }),
    async mounted() { this.accounts = await Services.getAccounts(this); this.loadMembers(); this.loadGroups() },
    methods: {
        loadGroups() {
            this.loading = true
            Request.do(this, 'POST', Request.getDefaultHeader(this), {}, Endpoints.companyGroups.filter, response => { this.groups = response?.results || []; this.loading = false }, () => { this.loading = false })
        },
        loadMembers() {
            Request.do(this, 'POST', Request.getDefaultHeader(this), { page: 1, pageSize: 500 }, Endpoints.systemUsers.companyUser.search, response => { this.groupAdmins = (response?.results || []).filter(user => ['GROUP_ADMIN', 'OPERATOR'].includes(user?.companyUser?.subtype)) })
        },
        save() {
            this.saving = true
            const payload = { ...this.form, accounts: this.form.accounts.map(idOf), members: this.form.members.map(idOf) }
            Request.do(this, this.form._id ? 'PUT' : 'POST', Request.getDefaultHeader(this), payload, `${Endpoints.companyGroups.companyGroup}${this.form._id || ''}`, response => {
                this.saving = false
                if (response?.status === 200) { Common.show(this, 'bottom-right', 'success', this.$t('str.form.update.success')); this.resetForm(); this.loadGroups() }
            }, () => { this.saving = false })
        },
        openCreateForm() { this.form = emptyForm(); this.isFormVisible = true },
        edit(group) { this.form = { ...group, accounts: (group.accounts || []).map(idOf), members: (group.members || []).map(idOf) }; this.isFormVisible = true },
        archive(group) { Request.do(this, 'DELETE', Request.getDefaultHeader(this), {}, `${Endpoints.companyGroups.companyGroup}${group._id}`, response => { if (response?.status === 200) { this.resetForm(); this.loadGroups() } }) },
        resetForm() { this.form = emptyForm(); this.isFormVisible = false },
        namesFor(values, options, label = 'name') { return (values || []).map(idOf).map(id => options.find(option => option._id === id)?.[label] || id).join(', ') },
    },
}
</script>
